import type { ReleaseDto } from '@technic/contracts';
import { apiFetch } from '@shared/api';

/**
 * Журнал обновлений портала (ADR 0077). Фабрики списка сюда не годятся: страницы, фильтров и
 * сортировки у ручки нет, а ответ — голый массив, и оборачивать его в `ListResponse` пришлось бы
 * ради полей, которые никто не заполнит.
 *
 * Параметров нет намеренно: сервер отдаёт последние два десятка выпусков, и это уже глубже, чем
 * журнал читают. «Загрузить ещё» в окне на один экран обслуживало бы археологию, а не вопрос
 * «что изменилось с прошлой недели».
 */
export const releasesApi = {
  list: () => apiFetch<ReleaseDto[]>('/releases'),
};
